<script setup lang="ts">
import { computed } from "vue";
import { ErrorIcon } from "../";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps<{
  errorCode: string | undefined;
}>();

const errorMessage = computed(() => {
  switch (props.errorCode) {
    case "RE001":
      return t("error.unknown_token");
    case "RE002":
      return t("error.inactive_customer");
    case "RE003":
      return t("error.invalid_token");
    case "RE004":
      return t("error.expired_token");
    case "RE005":
      return t("error.cancelled_token");
    case "RE006":
      return t("error.out_of_stock_product");
    case "RE007":
      return t("error.inactice_product");
    case "RE008":
      return t("error.processing");
    case "RE009":
      return t("error.too_soon");
    case "RE010":
      return t("error.out_of_funds");
    case "RE011":
      return t("error.unknown_token");
    case "RE012":
      return t("error.invalid_order_item");
    case "RE999":
    default:
      return t("error.general");
  }
});
</script>

<template>
  <div class="h-full">
    <div class="max-w-xl m-auto md:p-10 p-4">
      <div class="">
        <div class="bg-grey-300 md:p-6 rounded-2xl px-3 py-4">
          <div class="flex items-center mb-4">
            <div class="m-auto drop-shadow-xl">
              <ErrorIcon />
            </div>
          </div>

          <div class="text-lg md:text-2xl font-semibold text-center mb-2">
            {{ $t("error.title") }}
          </div>

          <div class="text-center text-sm md:text-base">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
